/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_OperationsInputs */

const en_waiting_on_operations = /** @type {(inputs: Waiting_On_OperationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on Operations`)
};

/**
* | output |
* | --- |
* | "Waiting on Operations" |
*
* @param {Waiting_On_OperationsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_operations = /** @type {((inputs?: Waiting_On_OperationsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_OperationsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_operations(inputs)
});